<template>
    <div>
        <component v-if="component" :is="component" :data="canvasObject"></component>
    </div>
</template>

<script>
    import moduleLoader from "../loader/Loader";

    export default {
        name: "SimpleCanvasObject",
        props: {
            canvasObject: {
                type: Object,
                default: () => ({})
            },
            canvasObjectsLength: {
                type: Number,
                default: 1
            }
        },
        methods: {
            loadComponent() {
                console.log('load dyn', this.canvasObject.getViewInObjectsConfigurator());
                //this.component =
            }
        },
        computed: {
            component() {
                const module = moduleLoader.loadModule(`canvas-object-types/${ this.canvasObject.getViewInObjectsConfigurator() }`, `canvas-object-types/Simple${ this.canvasObject.getViewInObjectsConfigurator() }`);
                return () => module;
            }
        },
        mounted() {
            //this.loadComponent();
        }
    }
</script>

<style scoped>

</style>